import NestJs from "../../../common/technologies/nestjs";
import Postgre from "../../../common/technologies/postgre";
import MongoDb from "../../../common/technologies/mongodb";
import Redis from "../../../common/technologies/redis";
import Docker from "../../../common/technologies/docker";
import Grpc from "../../../common/technologies/grpc";

function Minerva() {
  return (
    <div className={'portfolio-modal'}>
      <h1>Minerva</h1>
      <h4>Overview</h4>
      <p>
        The project is a database for information on capital raising, investment, mergers of corporations and startups globally.
        The system provides users with information on capital raising, investment, mergers of corporations and startups around the world. Users can explore many types of information about a business from organizational structure, fundraising information to investment deals and related information.
        <br/>
        The data in the system are crawled from third-party service, we have to analyze and structure them to fit the system.
      </p>
      <h4>The difficult parts</h4>
      <ul>
        <li>The main feature of the system is to search the needed information so we have to design database structure to optimize search query</li>
      </ul>
      <h4>My roles and responsibilities</h4>
      <ul>
        <li>Responsible for design database structure, search flow and store crawl data.</li>
      </ul>
      <h4>Technologies used</h4>
      <div className={'project-technologies'}>
        <NestJs />
        <Postgre />
        <MongoDb />
        <Redis />
        <Docker />
        <Grpc />
      </div>
      <h4>What I learnt from this project</h4>
      <ul>
        <li>Design database structure for searching</li>
        <li>Optimize query in mongo using aggregation</li>
      </ul>
    </div>
  )
}

export default Minerva;
